export const mutationType = {
  GET_LISTS: 'GET_LISTS',
  GET_BY_ID: 'GET_BY_ID',
  GET_TYPE_LISTS: 'GET_TYPE_LISTS',
  GET_TYPE_BY_ID: 'GET_TYPE_BY_ID',
}
